module.exports = __webpack_public_path__ + "img/Bärenjagt.519ef30a.jpg";